<template>
    <div
        class="accordion mt-3"
        v-for="cliente in operacion.clientes"
        :key="cliente.clienteId"
    >
        <div class="accordion-item mb-3 opcionDetalle">
            <h2 class="accordion-header" :id="`cliente${cliente.clienteId}`">
                <button
                    class="
                        accordion-button
                        collapsed
                        btn btn-primary
                        rounded-pill
                    "
                    type="button"
                    data-bs-toggle="collapse"
                    :data-bs-target="`#collapse${cliente.clienteId}`"
                    aria-expanded="false"
                    aria-controls="collapseCliente"
                >
                    {{ $filters.CapitalizeFilter(cliente.nombre) }}
                </button>
            </h2>
            <div
                :id="`collapse${cliente.clienteId}`"
                class="accordion-collapse collapse"
                :aria-labelledby="`cliente${cliente.clienteId}`"
                data-bs-parent="#accordionCliente"
            >
                <div class="accordion-body">
                    <div class="card card-body text-start cabeceraDetalle">
                        <p>Edad: {{ cliente.edadAnios }}</p>
                        <p>Nacionalidad: {{ $filters.StringFilter(cliente.nacionalidad) }}</p>
                        <p>Estado civil: {{ $filters.StringFilter(cliente.estadoCivil) }}</p>
                        <p>Régimen matrimonial: {{ $filters.StringFilter(cliente.regimenMatrimonial) ? $filters.StringFilter(cliente.regimenMatrimonial) : "Sin registro"  }}</p>
                        <p>Ciudad/Municipio: {{ $filters.StringFilter(cliente.ciudad) }}</p>
                        <p>Ocupación: {{ $filters.StringFilter(cliente.ocupacion) }}</p>
                        <p>Fecha de inscripción: {{ $filters.DateFilter(cliente.fechaInscripcion) }}</p>
                        <p>Sucursal de contratación: {{ $filters.StringFilter(cliente.sucursal) }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'DetalleCliente',

    props: {
        operacion: {}
    }
})
</script>

<style scoped>
    .texto,
    p,
    span {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 17px;
        line-height: 21px;
        color: #302d74;
    }

    .btn {
        z-index: 10;
        font-weight: 600;
        font-size: 18px;
    }
</style>
